import type { ReactNode } from 'react';

import { theme } from '@/lib/ui/theme';

export function PanelTitle({ children }: { children: ReactNode }) {
  return (
    <h2
      className="text-lg leading-none font-semibold"
      style={{ fontFamily: theme.fonts.body }}
    >
      {children}
    </h2>
  );
}
